/**
 * Enquiry
 * 
 * @Author: Focci
 * @Date: 2023-06-15 10:43:38
 * @Last Modified by: Focci
 * @Last Modified time: 2023-06-15 10:43:38
 */

'use client'

// import PropTypes from 'prop-types'
import { useTranslations } from 'next-intl'
import { useForm } from 'react-hook-form'
import { fetchPost } from '@lib/fetch/client'
import { Button } from '@comp/material'
import useMessage from '@hook/useMessage'
import ControllerFiled from '@comp/form/ControllerFiled'
import StyledInput from '@comp/form/StyledInput'

function Enquiry() {
  const tp = useTranslations('productspec')
  const { message } = useMessage()
  const form = useForm()

  async function onSubmit(param) {
    await fetchPost('productspec/enquiry', param)
    message('Successfully!')
    form.reset()
  }

  return (
    <div className="flex flex-col gap-4">
      <ControllerFiled
        name="name"
        inputProps={{ placeholder: tp('typeName') }}
        Input={StyledInput}
        form={form}
        rules={{ required: 'Name is required' }}
      />
      <ControllerFiled
        name="email"
        inputProps={{ placeholder: tp('typeEmail') }}
        Input={StyledInput}
        form={form}
        rules={{ 
          required: 'Email is required',
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: 'Invalid email address',
          }
        }}
      />
      <ControllerFiled
        name="phone"
        inputProps={{ placeholder: tp('typePhone') }}
        Input={StyledInput}
        form={form}
        rules={{ required: 'Phone is required' }}
      />
      <div className="h-24">
        <ControllerFiled
          name="content"
          Input={StyledInput}
          form={form}
          inputProps={{ 
            placeholder: tp('typeContent'), 
            multiline: true, 
            rows: 5
          }}
        />
      </div>
      <Button 
        size="large" 
        color="secondary"
        onClick={form.handleSubmit(onSubmit)}
      >
        {tp('send')}
      </Button>
    </div>
  )
}

// Enquiry.propTypes = {
//   inputType: PropTypes.string,
// }

export default Enquiry
